module.exports = __webpack_public_path__ + "static/media/minhduyen-logo.7a759ca8.png";